import { useCallback, useState } from 'react';
import {
  PwaAndroidInstallModal,
  PwaIosInstallModal,
} from '../components/PwaInstallGuideModals';
import { isAndroidDevice } from '../pwa/pwaInstallUtils';
import { usePwaInstall } from './usePwaInstall';

export function usePwaInstallFlow({ onAfterAction } = {}) {
  const { canShowInstall, hasNativePrompt, needsIosGuide, promptAndroidInstall } = usePwaInstall();
  const [iosGuideOpen, setIosGuideOpen] = useState(false);
  const [androidGuideOpen, setAndroidGuideOpen] = useState(false);

  const canShowInstallOffer = canShowInstall;

  const runInstallAction = useCallback(async () => {
    onAfterAction?.();

    if (hasNativePrompt) {
      await promptAndroidInstall();
      return;
    }

    if (needsIosGuide) {
      setIosGuideOpen(true);
      return;
    }

    if (isAndroidDevice()) {
      setAndroidGuideOpen(true);
    }
  }, [hasNativePrompt, needsIosGuide, onAfterAction, promptAndroidInstall]);

  const modals = (
    <>
      <PwaIosInstallModal show={iosGuideOpen} onClose={() => setIosGuideOpen(false)} />
      <PwaAndroidInstallModal show={androidGuideOpen} onClose={() => setAndroidGuideOpen(false)} />
    </>
  );

  return {
    canShowInstallOffer,
    runInstallAction,
    modals,
  };
}
